import Config from '../config';

const urlsReducer = (state = Config.urls, action) => {
    return {
        ...state,
        urls: action.urls
    };
};

export default urlsReducer;